<!--全局设置默认值     机构  单位  区域  产品
    机构：机构账号才有，默认选择当前账号的机构
    单位：单位账号默认选择当前账号的单位
    区域：默认当前账号的区域
    产品：无默认值

    默认值只是在表单中默认选择，不应该影响到当前用户所应该能获取到的信息
    即用户还可以自己去选择除默认值外的内容
-->
<template>
    <CellGroup>
        <Cell title="当前机构" :value="organName" is-link v-if="'Organs'===user.unit.type"
              @click="popupVisible.organ=true"/>
        <SelectTreePopup :show="popupVisible.organ" :defaultSelected="defaultOrgan" :treeData="organTree"
                         :defaultTitle="organName" @ok="onOrganOk" @cancel="onOrganCancel"/>

        <Cell title="当前单位" :value="unitName" :is-link="'Organs'===user.unit.type"
              @click="popupVisible.unit=true"/>
        <SelectTreePopup :show="popupVisible.unit" :defaultSelected="defaultUnit" :treeData="unitList"
                         :defaultTitle="unitName" @ok="onUnitOk" @cancel="onUnitCancel"/>

        <Cell title="当前区域" :value="areaName" is-link
              @click="popupVisible.area=true"/>
        <SelectTreePopup :show="popupVisible.area" :defaultSelected="defaultArea" :treeData="areaTree"
                         :defaultTitle="areaName" @ok="onAreaOk" @cancel="onAreaCancel"/>

        <Cell title="当前产品" :value="productName" is-link
              @click="popupVisible.product=true"/>
        <SelectProductPopup :show="popupVisible.product" :defaultSelected="defaultProduct" :products="productList"
                            :defaultTitle="productName" @ok="onProductOk" @cancel="onProductCancel"/>
        <Button type="info" class="float-btn" block @click="$router.go(-1)">返回</Button>
    </CellGroup>
</template>


<script>
    import {Button, Cell, CellGroup, Sticky} from "vant"
    import {mapGetters} from 'vuex';
    import SelectTreePopup from "@/components/SelectPopup/SelectTreePopup"
    import SelectProductPopup from "@/components/SelectPopup/SelectProductPopup"

    export default {
        components: {
            CellGroup, Cell, SelectTreePopup, SelectProductPopup, Sticky, Button
        },
        props:{},
        data() {
            return {
                popupVisible: {
                    organ: false,
                    unit: false,
                    area: false,
                    product: false,
                },
                unitListByOrgan: null,
                areaTreeByUnit: null,
                productListByUnit: null
            }
        },
        computed: {
            ...mapGetters({
                user: 'global/userInfo',
                organTree: 'global/organTree',
                units: 'global/unitList',
                areas: 'global/areaTree',
                products: 'global/productList',
                defaultOrgan: 'default/organ',
                defaultUnit: 'default/unit',
                defaultArea: 'default/area',
                defaultProduct: 'default/product',
            }),
            unitList() {
                return this.unitListByOrgan || this.units
            },
            areaTree() {
                return this.areaTreeByUnit || this.areas
            },
            productList() {
                return this.productListByUnit || this.products
            },
            organName() {
                return (this.defaultOrgan || {}).name || '选择机构'
            },
            unitName() {
                return (this.defaultUnit || {}).name || '选择单位'
            },
            areaName() {
                return (this.defaultArea || {}).name || '选择区域'
            },
            productName() {
                return (this.defaultProduct || {}).productName || '选择产品'
            },
        },
        created() {
            const {defaultOrgan} = this
            defaultOrgan && this.loadUnitListByOrgan(defaultOrgan)
        },
        mounted(){},
        methods: {
            onOrganOk(data) {
                this.setDefault('organ', data)
                this.popupVisible.organ = false
            },
            onOrganCancel() {
                this.popupVisible.organ = false
            },
            onUnitOk(data) {
                this.setDefault('unit', data)
                this.popupVisible.unit = false
            },
            onUnitCancel() {
                this.popupVisible.unit = false
            },
            onAreaOk(data) {
                this.setDefault('area', data)
                this.popupVisible.area = false
            },
            onAreaCancel() {
                this.popupVisible.area = false
            },
            onProductOk(data) {
                this.setDefault('product', data)
                this.popupVisible.product = false
            },
            onProductCancel() {
                this.popupVisible.product = false
            },
            setDefault(key, value) {
                this.$store.dispatch({type: 'default/setDefault', payload: {[key]: value}})
            },
            loadUnitListByOrgan(organ) {
                this.$http.tokiot.sys.unit.v2.list({currentSubUnit: true, id: organ.id, size: 9999, type: 'Unit'})
                    .then(ret => {
                        if (ret) {
                            const {rows} = ret;
                            this.unitListByOrgan = rows
                        }
                    })
            },
            loadAreaTreeByUnit(unit) {
                this.$http.tokiot.sys.area.v2.tree({currentSubArea: true, id: unit.areaId})
                    .then(ret => {
                        if (ret) {
                            this.areaTreeByUnit = [ret]
                        }
                    })
            },
            loadeProductListByUnit(unit) {
                this.$http.tokiot.sys.product.listAuthorized({unitId: unit.id})
                    .then(ret => {
                        if (ret) {
                            this.productListByUnit = ret
                        }
                    })
            },
            onChangeOrgan(organ) {
                this.setDefault('unit', null)
                this.loadUnitListByOrgan(organ)
                this.onChangeUnit(organ)
            },
            onChangeUnit(unit) {
                // 初始化区域
                const area = {
                    id: unit.areaId, name: unit.areaName,
                    code: unit.areaCode, type: unit.areaType,
                    lat: unit.lat, lng: unit.lng
                }
                this.setDefault('area', area)
                this.loadAreaTreeByUnit(unit)
                // 初始化产品
                this.setDefault('product', null)
                this.loadeProductListByUnit(unit)
            }
        },
        watch: {
            defaultOrgan(organ) {
                this.onChangeOrgan(organ)
            },
            defaultUnit(unit) {
                this.onChangeUnit(unit)
            },
            defaultArea(area) {
            },
            defaultProduct(product) {
            },
        }
    }
</script>

<style lang="less" scoped>

    .float-btn {
        position: fixed;
        bottom: 5px;
        z-index: 999;
        margin-left: 5px;
        width: calc(100% - 10px);
    }
</style>